export default function formatDateForApi(date, type) {
    if (!date) return "";
    const pad = (n) => (n < 10 ? "0" + n : n);
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    let hours = type === "start" ? "00" : "23";
    let minutes = type === "start" ? "00" : "59";
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }